import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-todo-date-option', {
  mixins: [eventListenerMixin],

  connected() {
    this.root = closest(this, '.todo-date-options');
    this.radio = this.querySelector('.todo-date-option-radio');

    this.listenTo(this.radio, {
      change: (e) => {
        if (e.target.value === 'no_due_date') {
          this.root.querySelector('.scheduling-due-date-only').handleClearLinkClick();
          this.root
            .querySelector('.scheduling-due-date-with-start tr-date-field')
            .handleClearLinkClick();
        } else if (e.target.value === 'due_date_with_start') {
          this.root.querySelector('.scheduling-due-date-only').handleClearLinkClick();
          this.querySelector('.mdc-select__selected-text').dispatchEvent(new Event('focusin'));
        } else if (e.target.value === 'due_date_only') {
          this.root
            .querySelector('.scheduling-due-date-with-start tr-date-field')
            .handleClearLinkClick();
          this.querySelector('.mdc-select__selected-text').dispatchEvent(new Event('focusin'));
        }
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
